"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { type ReactNode, useState } from "react";
import { trpc, trpcClientConfig } from "#/shared/api";

/**
 * tRPC + TanStack Query for App Router (`AppRootLayoutClient` / `AppShellProviders`).
 * Mirrors the former `api.withTRPC` wrapper (ssr: false).
 */
export const TrpcProvider: React.FC<{
  children: ReactNode;
}> = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp);
  const [trpcClient] = useState(_temp2);
  let t1;
  if ($[0] !== children || $[1] !== queryClient) {
    t1 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[0] = children;
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== queryClient || $[4] !== t1 || $[5] !== trpcClient) {
    t2 = <trpc.Provider client={trpcClient} queryClient={queryClient}>{t1}</trpc.Provider>;
    $[3] = queryClient;
    $[4] = t1;
    $[5] = trpcClient;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60000
      }
    }
  });
}
function _temp2() {
  return trpc.createClient(trpcClientConfig());
}